import { render, staticRenderFns } from "./positionList.vue?vue&type=template&id=8cfaf4fc&scoped=true"
import script from "./positionList.vue?vue&type=script&lang=js"
export * from "./positionList.vue?vue&type=script&lang=js"
import style0 from "./positionList.vue?vue&type=style&index=0&id=8cfaf4fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cfaf4fc",
  null
  
)

export default component.exports